import React__default from 'react';
import PropTypes from 'prop-types';
import { WarningIcon } from '../Icons/index.js';
import { ButtonLink } from '../Dashboard/Button.js';
import { ErrorWrapper, ErrorBox, MessageContainer } from './styles.js';

var Error = function Error(_ref) {
  var Message = _ref.Message,
    _goto = _ref["goto"];
  return /*#__PURE__*/React__default.createElement(ErrorWrapper, null, /*#__PURE__*/React__default.createElement(ErrorBox, null, /*#__PURE__*/React__default.createElement(WarningIcon, null), /*#__PURE__*/React__default.createElement(MessageContainer, null, Message ? /*#__PURE__*/React__default.createElement(Message, null) : /*#__PURE__*/React__default.createElement("h3", null, "Something went wrong")), _goto ? /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(ButtonLink, {
    href: _goto.url
  }, _goto.label)) : null));
};
Error.displayName = "Error";
Error.propTypes = {
  "goto": PropTypes.shape({
    url: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })
};

export { Error as default };
